import GoWorkLogInstance from "./instance";
const getAllDetail = async () => {
  const result = await GoWorkLogInstance.get("/datastore/admin");
  return result.data;
};
const postSave = async (req: any, oldId?: string) => {
  const result = await GoWorkLogInstance.post(
    `/datastore/entity/save?kind=information&id=${req.id}&namespace=Company&oldId=${oldId}`,
    req
  );
  return result.data;
};
const postDelete = async (id: string) => {
  const result = await GoWorkLogInstance.post(
    `/datastore/entity/delete?kind=information&id=${id}&namespace=Company`
  );
  return result.data;
};
export const adminApi = { getAllDetail, postSave, postDelete };
